import { Button, makeStyles } from "@material-ui/core";
import { NavigateBeforeSharp } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import LockIcon from "@material-ui/icons/Lock";
import React from "react";
import { Link } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { EMPTY_USER } from "../../../Models/Entities";
import { loggedUserState } from "../../../Store/atoms";

import "./styles.css";

export default () => {
  const setUser = useSetRecoilState(loggedUserState);
  const handleLogout = () => {
    setUser(EMPTY_USER);
    localStorage.removeItem("userId");
    localStorage.removeItem("jwt");
  };

  return (
    <nav className="nav">
      <div className="logo">CodeTables</div>
      <Link className="nav-item" to="/favorites">
        <div>My tables</div>
      </Link>
      <Link className="nav-item" to="/create-new-table">
        <div>Create new table</div>
      </Link>

      <Link className="nav-item" to="/browse-tables">
        <div>Browse tables</div>
      </Link>

      <div className="nav-item nav-item--end" onClick={handleLogout}>
        Log out
      </div>
    </nav>
  );
};
